import { render, staticRenderFns } from "./ProgressChartWidget.vue?vue&type=template&id=2521b9ae&scoped=true"
import script from "./ProgressChartWidget.vue?vue&type=script&lang=js"
export * from "./ProgressChartWidget.vue?vue&type=script&lang=js"
import style0 from "./ProgressChartWidget.vue?vue&type=style&index=0&id=2521b9ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2521b9ae",
  null
  
)

export default component.exports